import { FormSetCoinsToUser } from '@/components/forms';
import { TFormData } from '@/components/forms/formSetCoinsToUser';
import { broadcastService } from '@/services';
import { TCallbackForm } from '@/types';

type TParams = {
  disableInvalidateQueries?: boolean;
  callback?: TCallbackForm<TFormData>;
  user: {
    id: string;
    coins: number;
    username: string;
  };
};

const useFormSetCoinsToUser = () => {

  const openAddCreditsModal = (params: TParams) =>
    broadcastService
      .modal
      .show({
        content: <FormSetCoinsToUser {...params} />,
        width: 'lg'
      });

  return ({
    openAddCreditsModal
  });

};

export default useFormSetCoinsToUser;
